// extracted by mini-css-extract-plugin
export default {"tooltip":"tp-z","sharingV2":"up-z","sharingIconsV2":"vp-z","links":"wp-z","link":"xp-z","facebookV2":"yp-z","twitterV2":"zp-z","pinterestV2":"Ap-z"};